import { useState } from 'react'
import macWarning from '@/assets/macos-genie-warning.png'
import { MAC_DOWNLOAD_URL } from '@/lib/landing'
import { ButtonLink, DownloadIcon } from './primitives'

/** Keep first-launch guidance beside every direct macOS download. */
export function MacDownload() {
  const [showHelp, setShowHelp] = useState(false)
  const [imageFailed, setImageFailed] = useState(false)
  return (
    <div className="flex w-full flex-col gap-3 text-left">
      <ButtonLink href={MAC_DOWNLOAD_URL} className="w-full" onClick={() => setShowHelp(true)}>
        <DownloadIcon />
        Download for macOS
      </ButtonLink>
      <p className="text-[13px] leading-relaxed text-ink-2">
        <strong className="font-medium text-ink">macOS beta, not yet notarized by Apple.</strong> macOS may block Genie on first
        launch.
      </p>
      <details open={showHelp} className="rounded-[3px] bg-panel p-4 text-[13px] leading-relaxed text-ink-2">
        <summary
          onClick={(event) => {
            event.preventDefault()
            setShowHelp((open) => !open)
          }}
          className="mono-label cursor-pointer text-ink"
        >
          Installation help
        </summary>
        <p className="mt-3">After your download finishes:</p>
        {showHelp && !imageFailed && (
          <figure className="my-3">
            <img
              src={macWarning}
              onError={() => setImageFailed(true)}
              alt="macOS warning: Genie Not Opened, with Move to Trash and Done buttons. Choose Done to continue to Privacy & Security."
              width={656}
              height={630}
              className="mx-auto w-full max-w-[260px] rounded-[3px] border border-rule"
            />
            <figcaption className="mono-label mt-2 text-center text-ink-3">macOS on first launch</figcaption>
          </figure>
        )}
        <ol className="mt-2 list-decimal space-y-2 pl-5">
          <li>Open the DMG and drag Genie to Applications.</li>
          <li>
            Open Genie. If macOS says Apple could not verify it, click <strong>Done</strong>.
          </li>
          <li>
            Open <strong>System Settings → Privacy &amp; Security</strong>, then scroll to Security.
          </li>
          <li>
            Click <strong>Open Anyway</strong> next to Genie, then confirm <strong>Open</strong>. Your Mac may ask you
            to authenticate.
          </li>
        </ol>
        <p className="mt-3">Only approve a copy you downloaded from genie.art.</p>
        <a
          href="https://support.apple.com/102445"
          target="_blank"
          rel="noreferrer"
          className="mt-2 inline-block text-ink underline decoration-rule-strong underline-offset-4 hover:decoration-ink"
        >
          Apple’s guide to opening downloaded apps
        </a>
      </details>
    </div>
  )
}
